import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StorageIcon from '@mui/icons-material/Storage';

import { EMPTY_STRING } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { AnimatedStar } from '../../AnimatedStar';

interface Params {
  readonly categoryIds: readonly Id[];
  readonly isInternal: boolean;
  readonly isVip: boolean;
  readonly useItsEdmDomain: boolean;
}

export const FastIcons = ({
  categoryIds,
  isInternal,
  isVip,
  useItsEdmDomain,
}: Readonly<Params>) => {
  const { actorCategoriesCodeMap } = useReferencesContext();

  const vipLabel = 'VIP';
  const nonVipLabel = 'Pas VIP';

  const useItsEdmDomainLabel = 'Utiliser son Domaine GED';

  const isQuotationReceiver =
    !isInternal &&
    categoryIds.includes(actorCategoriesCodeMap.QuotationReceiver._id);
  const isQuotationEmitter =
    isInternal &&
    categoryIds.includes(actorCategoriesCodeMap.QuotationEmitter._id);
  const showReceipt = isQuotationReceiver || isQuotationEmitter;
  const receiptLabel = isQuotationReceiver
    ? 'Destinataire du Devis'
    : isQuotationEmitter
      ? 'Émetteur du Devis'
      : EMPTY_STRING;

  return (
    <>
      {!isInternal && (
        <Tooltip title={isVip ? vipLabel : nonVipLabel}>
          <Avatar aria-label={isVip ? vipLabel : nonVipLabel} sx={{ ml: 1 }}>
            {isVip ? <AnimatedStar /> : <StarBorderIcon />}
          </Avatar>
        </Tooltip>
      )}
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!(isInternal && useItsEdmDomain) && (
        <Tooltip title={useItsEdmDomainLabel}>
          <Avatar aria-label={useItsEdmDomainLabel} sx={{ ml: 1 }}>
            <StorageIcon />
          </Avatar>
        </Tooltip>
      )}
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!showReceipt && (
        <Tooltip title={receiptLabel}>
          <Avatar aria-label={receiptLabel} sx={{ ml: 1 }}>
            <ReceiptLongIcon />
          </Avatar>
        </Tooltip>
      )}
    </>
  );
};
